import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-else-return */
import { FlexBox, Modal, ModalBody, ModalHead, Page, Text, } from '@dixa/lib-shared-habla';
import { electron } from 'lib-shared-electron';
import moment from 'moment-timezone';
import { useCallback, useEffect, useState } from 'react';
import styles from './settingsAbout.view.module.scss';
import licenses from './utils/json/license.json';
import { getLicense } from './utils/licenseTexts';
export const SettingsAboutView = () => {
    const [activeLicense, setActiveLicense] = useState(null);
    const [appVersion, setAppVersion] = useState();
    useEffect(() => {
        if (!electron.isElectron()) {
            return;
        }
        electron.getVersion().then((version) => setAppVersion(version));
    }, []);
    const renderLicenseText = useCallback((license) => {
        var _a;
        const publisher = (_a = license.publisher) !== null && _a !== void 0 ? _a : '';
        if (license.licenses.indexOf('MIT') > -1) {
            return getLicense('MIT', publisher);
        }
        if (license.licenses.indexOf('ISC') > -1) {
            return getLicense('ISC', publisher);
        }
        if (license.licenses.indexOf('CC0-1.0') > -1) {
            return getLicense('CC0-1.0', publisher);
        }
        if (license.licenses === 'BSD-3-Clause') {
            return getLicense('BSD', publisher);
        }
        if (license.licenses === 'BSD-2-Clause' ||
            license.licenses.indexOf('BSD') > -1) {
            return getLicense('BSD2', publisher);
        }
        if (license.licenses.indexOf('Apache-2.0') > -1 ||
            license.licenses.indexOf('Apache License, Version 2.0') > -1 ||
            license.licenses.indexOf('Apache') > -1) {
            return getLicense('Apache-2.0', publisher);
        }
        if (license.licenses.indexOf('CC-BY-4.0') > -1) {
            return getLicense('CC-BY-4.0', publisher);
        }
        return null;
    }, []);
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "About" }), _jsxs(Page.Body, { children: [_jsxs(Page.Section, Object.assign({ title: `Dixa™ (build ${VERSION})${appVersion ? ` - (app version ${appVersion})` : ''}` }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: _jsxs("em", { children: [' ', "\u00A9 2015-", moment(TIMESTAMP.trim()).utc().format('Y'), " Dixa\u2122 All rights reserved."] }) })), _jsxs(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: ["The Dixa name, associated trademarks and logos are trademarks of Dixa or related entities.", _jsx("br", {}), "The software platform and this app are protected by international copyright laws and international treaties.", _jsx("br", {}), "Unauthorized reproduction or distribution of this software and app, or any portion thereof, is illegal and will be prosecuted."] }))] })), _jsx(Page.Section, Object.assign({ title: "Acknowledgements" }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", padding: "400", gap: "200", background: "neutral.100", borderRadius: "100", borderColor: "neutral.200", borderWidth: "100" }, { children: licenses.map((license, index) => (_jsxs(Text.Paragraph, Object.assign({ variant: "2", subdued: true, className: styles.license }, { children: [license.name, _jsxs(Text.ExternalLink, Object.assign({ href: "#", onClick: () => setActiveLicense(license) }, { children: ["License ", license.licenses] }))] }), index))) })) })), activeLicense && (_jsxs(Modal, Object.assign({ isOpen: true, allowClickOutside: true, className: styles.modal, onClose: () => setActiveLicense(null) }, { children: [_jsx(ModalHead, { title: "License", onClose: () => setActiveLicense(null) }), _jsx(ModalBody, { children: _jsx("pre", { children: renderLicenseText(activeLicense) }) })] })))] })] }));
};
